import { render, staticRenderFns } from "./OrderTaiwanTravel.vue?vue&type=template&id=4e439e10&scoped=true&"
import script from "./OrderTaiwanTravel.vue?vue&type=script&lang=js&"
export * from "./OrderTaiwanTravel.vue?vue&type=script&lang=js&"
import style0 from "./OrderTaiwanTravel.vue?vue&type=style&index=0&id=4e439e10&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e439e10",
  null
  
)

export default component.exports